import { useTranslation } from "react-i18next"

const FiltersBar = ({
  groupBy,
  onGroupByChange,
  companies,
  companyId,
  onCompanyChange,
  dateFrom,
  onDateFromChange,
  dateTo,
  onDateToChange,
  q,
  onQChange,
}) => {
  const { t } = useTranslation()

  return (
    <div className="bg-white rounded-2xl border border-[#E7EAEF] p-4 mb-4 flex flex-wrap items-end gap-3">
      <div className="flex rounded-xl border border-[#E7EAEF] overflow-hidden">
        {["company", "user"].map((option) => (
          <button
            key={option}
            onClick={() => onGroupByChange(option)}
            className={`px-3 py-2 text-sm font-medium transition-colors ${
              groupBy === option
                ? "bg-[#1F2937] text-white"
                : "bg-white text-[#1F2937] hover:bg-[#F4F6F9]"
            }`}
          >
            {t(`admin_saved_tours.group_by.${option}`)}
          </button>
        ))}
      </div>

      <div className="flex flex-col gap-1 flex-1 min-w-[200px]">
        <label className="text-xs text-[#9AA5B4]">{t("admin_saved_tours.filters.search")}</label>
        <input
          type="text"
          value={q}
          onChange={(e) => onQChange(e.target.value)}
          placeholder={t("admin_saved_tours.filters.search_placeholder")}
          className="px-3 py-2 rounded-xl border border-[#E7EAEF] text-sm text-[#1F2937] bg-white"
        />
      </div>

      <div className="flex flex-col gap-1">
        <label className="text-xs text-[#9AA5B4]">{t("admin_saved_tours.filters.company")}</label>
        <select
          value={companyId}
          onChange={(e) => onCompanyChange(e.target.value)}
          className="px-3 py-2 rounded-xl border border-[#E7EAEF] text-sm text-[#1F2937] bg-white min-w-[200px]"
        >
          <option value="">{t("admin_saved_tours.filters.all_companies")}</option>
          {companies.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-1">
        <label className="text-xs text-[#9AA5B4]">{t("admin_saved_tours.filters.date_from")}</label>
        <input
          type="date"
          value={dateFrom}
          onChange={(e) => onDateFromChange(e.target.value)}
          className="px-3 py-2 rounded-xl border border-[#E7EAEF] text-sm text-[#1F2937] bg-white"
        />
      </div>

      <div className="flex flex-col gap-1">
        <label className="text-xs text-[#9AA5B4]">{t("admin_saved_tours.filters.date_to")}</label>
        <input
          type="date"
          value={dateTo}
          onChange={(e) => onDateToChange(e.target.value)}
          className="px-3 py-2 rounded-xl border border-[#E7EAEF] text-sm text-[#1F2937] bg-white"
        />
      </div>

      {(q || companyId || dateFrom || dateTo) && (
        <button
          onClick={() => {
            onQChange("")
            onCompanyChange("")
            onDateFromChange("")
            onDateToChange("")
          }}
          className="px-3 py-2 rounded-xl border border-[#E7EAEF] text-sm font-medium text-[#9AA5B4] hover:bg-[#F4F6F9] transition-colors"
        >
          {t("admin_saved_tours.filters.reset")}
        </button>
      )}
    </div>
  )
}

export default FiltersBar
